import { Dropdown } from '@/components/Dropdown';
import { FC, useMemo } from 'react';
import { DependentDTO } from '../../../DTO/dependentsResponseDTO';

export const SelectDependentsNameInput: FC<{
    dependents: DependentDTO[];
    currentValue?: string;
    handleChangeCartValue: (target: string, type: 'name' | 'document') => void;
    shouldBlockEditing?: boolean
}> = ({ dependents, handleChangeCartValue, currentValue, shouldBlockEditing }) => {
    const dropdownElements = useMemo(() => {
        let rawResult = dependents;

        return rawResult.map(d => ({
            id: String(d.id),
            value: d.name,
        }));
    }, [dependents]);

    return (
        <Dropdown
            elements={dropdownElements}
            setCurrentSelected={value => {
                handleChangeCartValue(value, 'name');
            }}
            title={currentValue ?? 'Selecione um dependente'}
            allSize={true}
            currentSelected={currentValue}
            wrapperClassName={"dependents-dropdown " + (shouldBlockEditing ? "readonly" : "")}
        />
    );
};
